import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import {
  buildMultilingualString,
  flagToLocaleMap,
  getAvailableLocales,
  getTextForLocaleStatic,
  localeToFlagMap,
  parseMultilingualString,
  translateMultilingualArray,
  translateMultilingualValuesInObject,
} from '@/utils/multilingualCore';

export function useMultilingualText() {
  const { locale } = useI18n();

  function getTextForLocale(text: string | undefined): string {
    return getTextForLocaleStatic(text, locale.value);
  }

  function useTranslatedData<T extends object>(rawData: T, editMode: boolean | (() => boolean)) {
    return computed(() => {
      const isEditing = typeof editMode === 'function' ? editMode() : editMode;

      if (isEditing) {
        return rawData;
      }

      return translateMultilingualValuesInObject(rawData, locale.value);
    });
  }

  return {
    flagToLocaleMap,
    localeToFlagMap,
    parseMultilingualString,
    buildMultilingualString,
    getTextForLocale,
    getAvailableLocales,
    translateMultilingualValuesInObject,
    translateMultilingualArray,
    useTranslatedData,
  };
}

export function useTranslatedData<T extends object>(
  rawData: T,
  editMode: boolean | (() => boolean),
) {
  const { locale } = useI18n();
  return computed(() => {
    const isEditing = typeof editMode === 'function' ? editMode() : editMode;

    if (isEditing) {
      return rawData;
    }

    return translateMultilingualValuesInObject(rawData, locale.value);
  });
}
